import { useEffect, useRef, useState } from 'react';

import { nowUnix } from '../datetimeUtils';

export function useThrottleValue<T>(value: T, delay = 300) {
  const [throttled, setThrottled] = useState(value);
  const lastRan = useRef(nowUnix());

  useEffect(() => {
    const now = nowUnix();
    const remaining = delay - (now - lastRan.current);

    if (remaining <= 0) {
      lastRan.current = now;
      setThrottled(value);
      return;
    }

    const id = window.setTimeout(() => {
      lastRan.current = Date.now();
      setThrottled(value);
    }, remaining);

    return () => window.clearTimeout(id);
  }, [value, delay]);

  return throttled;
}
